import { addDays, isAfter, startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { LocalStorageCache } from 'src/services/cache/LocalStorageCache';

const TIME_ZONE_TAIWAN = 'Asia/Taipei';
const FIRST_ACCESS_TIMESTAMP_KEY = 'firstAccessUnixTimestamp';
const PRODUCT_PAGE_VIEW_COUNT_KEY = 'productPageViewCount';
const PREV_IS_FOLLOWING_DAY_ACCESS_KEY = 'prevIsFollowingDayAccessCache';
const APP_LEADING_BANNER_DISPLAY_THRESHOLD = 3;
const FALSE = 0;

const firstAccessTimestampCache = new LocalStorageCache(FIRST_ACCESS_TIMESTAMP_KEY, 0);
export const productPageViewCountCache = new LocalStorageCache(PRODUCT_PAGE_VIEW_COUNT_KEY, 0);

export const prevIsFollowingDayAccessCache = new LocalStorageCache(PREV_IS_FOLLOWING_DAY_ACCESS_KEY, FALSE);

export const getIsFollowingDayAccess = (): boolean => {
  const currentTaiwanTime = toZonedTime(new Date(), TIME_ZONE_TAIWAN);
  const firstAccessTimestamp = firstAccessTimestampCache.get();
  const isFirstAccess = firstAccessTimestamp === 0;
  if (isFirstAccess) {
    firstAccessTimestampCache.set(currentTaiwanTime.getTime());
    return false;
  }

  const firstAccessTime = new Date(firstAccessTimestamp);
  const nextDayAfterFirstAccess = startOfDay(addDays(firstAccessTime, 1));
  const isFollowingDayAccess = isAfter(currentTaiwanTime, nextDayAfterFirstAccess);
  return isFollowingDayAccess;
};

export const getIsMoreThanThreeTimes = (): boolean => {
  const currentCount = productPageViewCountCache.get();
  productPageViewCountCache.set(currentCount + 1);
  const productPageViewCount = productPageViewCountCache.get();
  return productPageViewCount >= APP_LEADING_BANNER_DISPLAY_THRESHOLD;
};

export const resetAppBannerDisplayConditionCache = () => {
  productPageViewCountCache.delete();
  firstAccessTimestampCache.delete();
};
